import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js'
import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import WalletIcon from '../../../Assets/images/wallet.svg'
import { API_URL } from '../../../server'
import './PaymentModal.css'
import Line from '../Line/Line'

export default function WalletModal ({ stripmodal, closestripModal }) {
  const stripe = useStripe()
  const elements = useElements()
  const navigate = useNavigate()

  const [clientSecret, setClientSecret] = useState('')
  const [striploading, setStriploading] = useState(false)
  const [isProcessing, setIsProcessing] = useState(false)
  const [sessionCount, setSessionCount] = useState('')
  const [errorModule, setErrorModule] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')
  const [totalsession, setTotalsession] = useState('')
  const [cuurency, setCuurency] = useState('')
  const [price, setPrice] = useState()
  const [loader, setLoader] = useState(false)

  const data = [
    { title: 'Session', amount: 1 },
    { title: 'Sessions', amount: 3 },
    { title: 'Sessions', amount: 6 },
    { title: 'Sessions', amount: 12 }
  ]

  useEffect(() => {
    getsessions()
    getAmount()
  }, [])

  useEffect(() => {
    if (stripmodal) getsessions()
    getAmount()
  }, [stripmodal])

  const getsessions = async () => {
    try {
      const registerid = sessionStorage.getItem('registerid')
      const myHeaders = new Headers()
      myHeaders.append('Content-Type', 'application/json')

      const raw = JSON.stringify({
        user_id: registerid
      })

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      }
      const response = await fetch(
        API_URL + 'getWalletCounById',
        requestOptions
      )
      const result = await response.json()
      console.log('session count', result)
      if (!response.ok) {
        throw new Error('Data not found')
      }
      setTotalsession(result?.data?.sessionCount)
    } catch (error) {
      console.log('error', error)
    }
  }

  const getAmount = async () => {
    try {
      const token = sessionStorage.getItem('token')
      const myHeaders = new Headers()
      myHeaders.append('Authorization', 'Bearer ' + token)

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        redirect: 'follow'
      }
      const response = await fetch(
        API_URL + 'getAdminSessionPrice',
        requestOptions
      )
      const result = await response.json()
      console.log('getAdminSessionPrice', result)
      if (!response.ok) {
        throw new Error('Data not found')
      }
      setCuurency(result?.data[0]?.currency)
      console.log('naviagtioncuurency' + result?.data[0]?.currency)
      setPrice(Number(result?.data[0]?.sessionPrice))
    } catch (error) {
      console.log('error', error)
    }
  }

  const CalulateAmount = data => {
    const sessionData = Number(data)
    const sessionPrice = Number(price)
    const amount = sessionData * sessionPrice
    console.log(amount)
    const TotalAmount = amount * 100
    console.log('CalculateAmount', TotalAmount)
    return TotalAmount
  }

  const paymentintent = data => {
    const sessionValue = data || sessionCount

    closestripModal()
    getAmount()
    navigate('/SettingsMainScreen/SettingPaymentDetails', {
      state: {
        // clientSecret: result,
        sessionCount: sessionValue,
        currency: cuurency,
        totalAmount: CalulateAmount(sessionValue),
        price: price
      }
    })
    sessionStorage.setItem('viapayment', true)

    setLoader(false)
  }

  useEffect(() => {
    handleSession()
  }, [])

  const handleSession = async () => {
    try {
      const registerid = sessionStorage.getItem('registerid')

      const response = await fetch(API_URL + 'getWalletCounById', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: registerid })
      })

      if (!response.ok) throw new Error('Something went wrong')

      const result = await response.json()
      console.log('Wallet Data:', result)
      setSessionCount(result?.sessionCount || 0)
    } catch (error) {
      console.error('Error fetching wallet data:', error)
    } finally {
      setIsProcessing(false)
    }
  }

  return (
    <Modal
      centered
      show={stripmodal}
      onHide={closestripModal}
      className='flex items-center m-0 rad'
    >
      <Modal.Body className='modalbackgroundcolor  p-4 items-center rounded-lg'>
        {/* Close Button */}
        <div className='d-flex justify-content-end'>
          <button className='btn-close' onClick={closestripModal}></button>
        </div>

        {/* Wallet Header */}
        <h3 className='fw-bold mb-3 textfam' style={{ fontSize: '28px' }}>
          Wallet
        </h3>

        {/* Available Balance */}
        <div className='wallet-balance d-flex justify-content-between align-items-center p-4 rounded stripmodal-crad1'>
          {/* Left Side: Wallet Icon */}
          <img
            src={WalletIcon}
            alt='Wallet'
            className='wallet-icon w-16 h-16'
          />

          {/* Right Side: Text & Balance */}
          <div className='textfam px-4'>
            <p
              className='text-[16px]'
              style={{
                fontWeight: '600',
                fontFamily: 'Avenir Next'
              }}
            >
              Available balance
            </p>

            <strong
              className='fs-4'
              style={{ fontSize: 18, fontWeight: 'bold' }}
            >
              {totalsession ? totalsession : '0'} Sessions
            </strong>
          </div>
        </div>

        {/* Wallet Info */}
        <div className='wallet-info' style={{ paddingTop: 20 }}>
          <h6 className='fw-bold textfam' style={{ paddingTop: 20 }}>
            Refill with a session pack
          </h6>
          <p className='' style={{ paddingTop: 10, fontSize: 14 }}>
            Top-up your wallet with more sessions that you can use anytime
            across all subjects without an expiry date.
          </p>
        </div>

        <div className='mt-3'>
          {' '}
          <Line />
        </div>

        {/* Session Selection */}

        {/* <strong
              className='fs-4'
              style={{ fontSize: 18, fontWeight: 'bold' }}
            >
              {totalsession ? totalsession : '0'} Sessions
            </strong> */}
        

         <div className='stripmodal-card-wrapper'>
          {data.map((item, i) => (
            <div
              key={i}
              className='stripmodal-crad'
              onClick={() => paymentintent(item.amount)}
            >
              <span className='fw-bold'>{item.amount}</span>
              <p className='fw-bold textfam' style={{fontSize:18}}>{item.title}</p>
            </div>
          ))}
        </div>

        {/* Payment Processing */}
        {clientSecret && (
          <div className='payment-container mt-4'>
            {striploading ? (
              <div className='d-flex justify-content-center mt-3'>
                <div className='spinner-border text-dark' role='status'></div>
              </div>
            ) : (
              <>
                <div className='card-element-container'>
                  <CardElement />
                </div>
                <button className='btn btn-primary mt-3 w-100'>
                  Proceed to Pay
                </button>
              </>
            )}
          </div>
        )}
      </Modal.Body>
    </Modal>
  )
}

// if (!sessionValue) {
//   setErrorModule(true);
//   return setErrorMsg("Please Select or Enter a Session");
// }
// setLoader(true);
// const registerid = sessionStorage.getItem('registerid');
// const customerId = sessionStorage.getItem('customerId');

// const myHeaders = new Headers();
// myHeaders.append("Content-Type", "application/json");

// const raw = JSON.stringify({
//   "customerId": customerId,
//   "amount": CalulateAmount(sessionValue),
//   "currency": cuurency?.toLocaleUpperCase(),
//   "sessionCount": sessionValue,
//   "user_id": registerid
// });
// console.log("raw", raw);
// const requestOptions = {
//   method: "POST",
//   headers: myHeaders,
//   body: raw,
//   redirect: "follow"
// };

// fetch(API_URL + "createPaymentIntent", requestOptions)
//   .then((response) => response.json())
//   .then((result) => {
//     console.log("createPaymentIntent", result);
//     if (result.success == true) {

//   }
//   else {
//     setErrorMsg(result.error);
//     setErrorModule(true);
//     setLoader(false);
//   }
// })
// .catch((error) => console.error(error))
// .finally(() => {
//   setLoader(false);
// });
